import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import React, {useEffect} from "react";
import {Button, Grid} from "@mui/material";
import {ArrowBack, CarCrashOutlined, CardMembershipOutlined, Check, CreditCard, WhatsApp} from "@mui/icons-material";

export const FormularioProcesado = ({
                                        formulario,
                                        siguiente,
                                        anterior,
                                        paso,
                                        datos,
                                        ultimo,
                                        setDatos,
                                        finalizar,
                                        cargando
                                    }) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})

    let Elento = formulario

    const guardarDatos = async () => {
        let entidad = await obtenerEntidad()
        siguiente(entidad)
    }

    const finalizar_ = async () => {
        let entidad = await obtenerEntidad()
        setDatos(entidad)
        console.log(datos)
        await finalizar(entidad)
    }

    useEffect(() => {
        console.log()
    }, [props.watch()])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{marginTop: 2, marginBottom: 4}}>
                <Elento props={props}/>
            </Grid>


            {ultimo &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 4}}>
                    <Button
                        loading={cargando}
                        onClick={() => finalizar_()}
                        fullWidth
                        startIcon={<Check/>}
                        sx={{pt: 1.5, pb: 1.2, fontWeight: 400}}
                    >Finalizar Registro</Button>
                </Grid>
            }


            <Grid container size={{xs: 6, sm: 6, md: 6}}>
                {paso > 0 &&
                    <Button
                        onClick={() => anterior()}
                        variant={'text'} sx={{width: 130}} startIcon={<ArrowBack/>}>Atras</Button>
                }
            </Grid>


            {!ultimo &&
                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>


                    <Button
                        variant={'outlined'}
                        onClick={() => guardarDatos()}
                        endIcon={<Check/>} sx={{width: 130}}>Siguiente</Button>


                </Grid>
            }

        </Grid>

    )


}